import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-07-10
 * @brief SEI 에너지컨설팅 - 회사 선택 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, curConsultingState, mainState } from "../../../recoil/assessmentState";
import { loadingBoxState, urlState } from "../../../recoil/menuState";
import { demo, userInfoLoginState } from "../../../recoil/userState"; // recoil
// utils
import { langId } from "../../../recoil/langState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
function ConsultingHeader(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilUrlInfo = useSetRecoilState(urlState);
    const setReLoad = useSetRecoilState(loadingBoxState);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curConsultingState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    //props
    const { setChangeZone, setEtype, setStype, setEtypeB, setStypeB } = props;
    const [companyItem, setCompanyItem] = useState([]);
    const [toogle, setToogle] = useState(false);
    const demos = useRecoilValue(demo);
    // Tree API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/zone/filter`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds,
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                if (userInfo.role == CONST.USERROLE_ENGINEER) {
                    setRecoilUrlInfo(CONST.URL_TODAYINSPECTION);
                    navigate(CONST.URL_TODAYINSPECTION);
                }
                let treeItem = data.body;
                if (treeItem.length > 0) {
                    let curComapy = treeItem.filter((item) => item.zoneId == recoilState.zoneId).length > 0
                        ? treeItem.filter((item) => item.zoneId == recoilState.zoneId)[0]
                        : treeItem[0];
                    setCompanyItem(data.body);
                    setChangeZone(treeItem);
                    setRecoilTreeData({
                        companyId: curComapy.companyId,
                        name: curComapy.name,
                        zoneId: curComapy.zoneId,
                    });
                    setRecoilState({
                        companyId: curComapy.companyId,
                        zoneId: curComapy.zoneId,
                    });
                }
                else {
                    if (userInfo.role !== CONST.USERROLE_NONE) {
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "reset", type: CONST.TYPE_NONE, divTag: t("라벨.현재사업장이없어서운영관리화면으로이동합니다") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    else {
                        navigate(CONST.URL_NOT_FOUND);
                    }
                    setRecoilState({
                        companyId: "",
                        zoneId: "",
                    });
                }
            }
        }
    }, [data, langIds]);
    function ConsultionClick(e, item) {
        e.preventDefault();
        setRecoilTreeData({
            companyId: item.companyId,
            name: item.name,
            zoneId: item.zoneId,
        });
        setRecoilState({
            companyId: item.companyId,
            zoneId: item.zoneId,
        });
        setToogle(false);
        if (recoilTreeData.zoneId !== item.zoneId) {
            setReLoad(true);
            setChangeZone(item);
            setEtype(1);
            setStype(1);
            setEtypeB(true);
            setStypeB(true);
            window.scrollTo({
                top: 0,
            });
        }
    }
    function ToogleClick(e) {
        if (!toogle) {
            setToogle(true);
        }
        else {
            setToogle(false);
        }
    }
    const zoneOpen = (e) => {
        CUTIL.onClickSelect(e, CUTIL.selectOption);
        CUTIL.selectFoucs(recoilTreeData.zoneId);
    };
    // 트리 이외 다른곳 닫기
    useEffect(() => {
        const handleClick = (e) => {
            //e.preventDefault();
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("select__toggleBtn") || targetElement.closest(".select__toggleBtn");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select__toggleBtn");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
                setToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsx(_Fragment, { children: companyItem && (_jsx("div", Object.assign({ className: "box__header" }, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx("div", Object.assign({ className: "flex-inline m-none" }, { children: _jsxs("div", Object.assign({ className: "select ml-25", onClick: (e) => zoneOpen(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTreeData.name })), _jsx("div", { className: "arrow" })] })), !demos ? (_jsx("ul", { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: `option ${item.zoneId == recoilTreeData.zoneId ? "active" : ""}`, id: item.zoneId, title: item.name, onClick: (e) => ConsultionClick(e, item) }, { children: item.name }), "consluting_" + idx.toString()))) })) : (_jsx("ul", { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: recoilTreeData.zoneId == item.zoneId ? "on" : "", id: item.zoneId, title: item.name, onClick: (e) => location.reload() }, { children: item.name }), "consluting_" + idx.toString()))) }))] })) })), _jsx("div", Object.assign({ className: `select__toggleBtn ${toogle ? "active" : ""}`, onClick: (e) => ToogleClick(e) }, { children: _jsx("p", { children: recoilTreeData.name }) })), _jsx("div", Object.assign({ className: `box selectbar menutype ${toogle ? "active" : ""}` }, { children: _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: companyItem.map((item, idx) => (_jsx("li", Object.assign({ className: recoilTreeData.zoneId == item.zoneId ? "on" : "", onClick: (e) => ConsultionClick(e, item), title: item.name }, { children: _jsx("a", Object.assign({ href: "#", id: "m" + item.zoneId }, { children: _jsx("p", { children: item.name }) })) }), "consluting_" + idx.toString()))) })) })) }))] })) }))) }));
}
export default ConsultingHeader;
